import { LockFilled } from '@ant-design/icons';
import { FlexRow } from '@framework/ui/components/row/FlexRow.tsx';
import { Tooltip } from 'antd';
import type React from 'react';
import { useTranslation } from 'react-i18next';
import { type ISubmissionMenuItem } from './ISubmissionMenuItem.tsx';
import { SubmissionMenuLabel } from './SubmissionMenuLabel.tsx';

export interface ISubmissionMenuItemProps {
  item: ISubmissionMenuItem;
  badge?: React.ReactNode;
  disabled?: boolean;
}

export function SubmissionMenuItem(props: ISubmissionMenuItemProps) {
  const { item, badge, disabled } = props;
  const { t } = useTranslation();

  if (!item) return null;

  const disableText = t(
    'submission-menu-item.sezione-disabilitata',
    'Sezione disabilitata',
  );

  return (
    <FlexRow
      gutter={4}
      right={badge}
      left={
        disabled ? (
          <Tooltip title={disableText}>
            <span className="sr-only">{disableText}.</span>
            <LockFilled aria-hidden="true" />
          </Tooltip>
        ) : undefined
      }
    >
      <SubmissionMenuLabel item={item} />
    </FlexRow>
  );
}
